import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'
import { tryExportDataXlsx } from 'redux/actions/Utilities'

import * as actions from './actions'

import { TWidgetSettings, FormattedWidgetData } from 'types/GlobalWidget'

import { convertWidgetDataToExport } from 'utils/widgetExport'

function tryExportWidgetDataXlsx(
  settings: TWidgetSettings,
  formattedData: FormattedWidgetData,
  fileName: string,
  totalLabel: string,
  variantOptionsLabel: string
) {
  return (dispatch: Dispatch) => {
    // Convert to export format
    const { headers, rows } = convertWidgetDataToExport(
      settings,
      formattedData,
      totalLabel,
      variantOptionsLabel
    )

    // Call the thunk directly with dispatch
    const exportThunk = tryExportDataXlsx(headers, rows, fileName)

    exportThunk(dispatch)
  }
}

function invalidateWidgets() {
  return (dispatch: Dispatch) => {
    dispatch(actions.invalidateWidgets())
  }
}

export const useWidgetActions = () => {
  return {
    tryExportWidgetDataXlsx: useThunkActions(tryExportWidgetDataXlsx),
    invalidateWidgets: useThunkActions(invalidateWidgets)
  }
}
